import { useContext, useEffect, useState } from 'react'
import Button from 'ui/src/components/controls/button'
import TextInput from 'ui/src/components/controls/text-input'
import { EditPanelFieldComponentProps } from '..'
import { Cta } from '../../../types'
import { CONTROL_SIZE, CONTROL_SIZE_SLIM, SAVE_BUTTON_LABEL, SAVE_BUTTON_WIDTH } from '../../constants'
import { EditPanelFieldContext } from '../../contexts/field'
import { EditPanelContext } from '../../contexts/panel'
import { titleFromField, valueKeyFromField } from '../../utilities/field'
import { sharedValueFromGifs } from '../../utilities/gifs'

export default ({ className, field, gifId, size: sizeProp }: EditPanelFieldComponentProps) => {
    const { colors, gifs, isCompact } = useContext(EditPanelContext)
    const { changeField } = useContext(EditPanelFieldContext)
    const size = sizeProp || (isCompact ? CONTROL_SIZE_SLIM : CONTROL_SIZE)
    const title = titleFromField(field)
    const placeholder = `Add ${title.toLowerCase()}`
    const key = valueKeyFromField(field)
    const sourceKey = valueKeyFromField('source')
    const defaultValue = sharedValueFromGifs<string>(gifs, key, gifId) || ''
    const source = sharedValueFromGifs<string>(gifs, sourceKey, gifId) || ''
    const [value, setValue] = useState<string>(defaultValue)

    function onSave() {
        if (value !== defaultValue) {
            changeField<Cta>(field, {
                link: value ? source : '',
                text: value,
            })
        }
    }

    useEffect(() => {
        setValue(defaultValue)
    }, [gifId])

    return (
        <TextInput
            className={className}
            color={colors.input}
            placeholder={placeholder}
            size={size}
            value={value}
            onChange={setValue}
            onEnterKeyPress={() => onSave()}
        >
            <Button
                color={colors.saveButton || colors.button}
                size={size}
                textColor={colors.saveButtonText || colors.buttonText}
                style={{ width: SAVE_BUTTON_WIDTH }}
                onClick={() => onSave()}
            >
                {SAVE_BUTTON_LABEL}
            </Button>
        </TextInput>
    )
}
